var _style, _rect, _ellipse, _g, _g2, _path, _path2, _rect2, _defs, _g3, _path3, _path4, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4300 4300",
    style: {
      enableBackground: "new 0 0 4300 4300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FEBC10;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E0A40D;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCC4A;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#B8B8B8;}\r\n\t.st7{clip-path:url(#XMLID_97_);}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#2B87C9;}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#75C6FF;}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#454441;}\r\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#3AABFC;}\r\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#61605C;}\r\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#383735;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_96_",
    x: 136.3,
    y: 135.5,
    className: "st0",
    width: 4028,
    height: 4028
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_95_",
    className: "st1",
    cx: 2150.3,
    cy: 3666.3,
    rx: 717.3,
    ry: 36.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_94_",
    className: "st2",
    points: "2799.6,2472 2395.8,2727.4 2220.8,2460 2884.1,2065.6 3160.9,2426.6 3499.9,2237  3657,2502.2 3079.5,2824.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_93_",
    className: "st1",
    points: "3560.1,2476.1 3474.5,2331.5 3142.2,2517.3 2866.4,2157.7 2319.4,2482.8  2416.7,2631.3 2815.4,2379.1 3097.4,2734.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_92_",
    x: 3442.2,
    y: 2188.5,
    transform: "matrix(0.8508 -0.5255 0.5255 0.8508 -726.2326 2215.6025)",
    className: "st2",
    width: 193.2,
    height: 396.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_91_",
    className: "st2",
    points: "3678.7,2226.5 3740.1,2324.8 3881.4,2236.3 3976.7,2388.5 3667.1,2582.2  3415.2,2179.6 3724.7,1985.9 3820,2138.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_90_",
    className: "st1",
    points: "3589.9,2206.1 3731.2,2117.7 3704.3,2074.6 3503.9,2200 3687.5,2493.5 3887.9,2368.1  3861,2325.1 3719.7,2413.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_89_",
    x: 3506.6,
    y: 2252.9,
    transform: "matrix(0.8508 -0.5255 0.5255 0.8508 -726.2326 2215.6094)",
    className: "st3",
    width: 64.4,
    height: 267.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_88_",
    className: "st4",
    points: "3471.1,2338.4 3499.2,2320.4 3502.1,2318.6 3525.4,2303.8 3495.9,2256 3472.1,2270.7  3467.6,2273.4 3444.6,2287.7 3441.1,2289.8 3441.2,2290  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st5",
    d: "M3551.2,2468.2c21.1-12,34.9-21.3,54.8-33.9l30.5,49.4c-23.6,14.1-32,20-54.8,33.8 L3551.2,2468.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_86_",
    className: "st6",
    points: "3718,2474.4 3527.8,2185.1 3503.9,2200 3687.5,2493.5 3709.7,2479.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_85_",
    className: "st0",
    points: "3665.4,2099 3693.3,2141.4 3731.2,2117.7 3704.3,2074.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_84_",
    className: "st0",
    points: "3861,2325.1 3827.7,2345.9 3855.6,2388.3 3887.9,2368.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_83_",
    className: "st6",
    points: "2714.8,2307.4 2852.6,2216.7 3136.1,2584.7 3439.8,2410.2 3412.5,2366.1  3142.2,2517.3 2866.4,2157.7 2724.6,2241.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_82_",
    className: "st0",
    points: "2827.6,2324.2 2699.4,2409.7 2692.3,2456.9 2815.4,2379.1 3097.4,2734.7  3500.9,2509.2 3483.1,2480.5 3117.3,2676.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_81_",
    className: "st2",
    points: "3341.1,2645.3 3224.2,2420.8 3161.4,2454.2 3280.6,2671.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_80_",
    className: "st2",
    points: "3092.6,2418.2 2917.1,2562.8 2875.7,2506.8 3046.2,2364.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_79_",
    className: "st2",
    points: "2814.4,2424.8 2727.2,2187 2674.8,2241.1 2746.1,2444.4  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_78_",
    className: "st2",
    points: "1475.5,2397.6 1836.9,2085 2049.7,2323.4 1452.4,2812 1125,2496.1 817.9,2734  623.2,2495.1 1146.3,2090.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_77_",
    className: "st1",
    points: "722.9,2506.5 829,2636.8 1130,2403.6 1456.2,2718.3 1948.8,2315.5 1830.6,2183.1  1473.7,2491.8 1142.1,2182  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_76_",
    x: 660.6,
    y: 2393.4,
    transform: "matrix(0.7633 -0.646 0.646 0.7633 -1495.0697 1102.5972)",
    className: "st2",
    width: 193.2,
    height: 396.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_75_",
    className: "st2",
    points: "642.7,2770.9 567.4,2682.9 440.7,2791.3 323.9,2655 601.3,2417.4 910.3,2778.1  632.9,3015.7 516.1,2879.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_74_",
    className: "st1",
    points: "733.5,2777.9 606.9,2886.4 639.9,2924.9 819.5,2771.1 594.3,2508.2 414.7,2662  447.7,2700.5 574.4,2592.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_73_",
    x: 725,
    y: 2457.8,
    transform: "matrix(0.7633 -0.646 0.646 0.7633 -1495.0684 1102.5942)",
    className: "st3",
    width: 64.4,
    height: 267.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_72_",
    className: "st4",
    points: "831.4,2629.4 806.2,2651.4 803.6,2653.6 782.8,2671.7 819.1,2714.6 840.4,2696.6  844.4,2693.1 865.1,2675.6 868.2,2673 868.1,2672.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st5",
    d: "M732.8,2513c-19,15-31.3,26.3-49.1,41.6l-37.5-44.3c21.2-17.4,28.6-24.5,49.2-41.6L732.8,2513 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_70_",
    className: "st6",
    points: "567,2531.6 798,2789.5 819.5,2771.1 594.3,2508.2 574.4,2525.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_69_",
    className: "st0",
    points: "674.8,2895.1 640.9,2857.3 606.9,2886.4 639.9,2924.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_68_",
    className: "st0",
    points: "447.7,2700.5 477.6,2675 443.7,2637.2 414.7,2662  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_67_",
    className: "st6",
    points: "1583.9,2547.8 1461,2657.9 1126.1,2336.1 851.7,2553.7 885.2,2593.3 1130,2403.6  1456.2,2718.3 1583.9,2613.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_66_",
    className: "st0",
    points: "1469.8,2547.9 1583.9,2444.3 1583.9,2396.5 1473.7,2491.8 1142.1,2182 776.5,2465  798.3,2490.7 1131,2242.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_65_",
    className: "st2",
    points: "914.4,2306.6 1063.2,2511.3 1120.4,2468.9 970.2,2271.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_64_",
    className: "st2",
    points: "1193.8,2494.3 1345.9,2325.2 1395.2,2374.5 1247.7,2540.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_63_",
    className: "st2",
    points: "1468,2446.4 1589.5,2668.6 1633.2,2607.3 1532.5,2416.9  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st2",
    d: "M1999.3,2811.3h284.1c54.1,0,98.4,44.3,98.4,98.5v49.6c0,54.1-44.3,98.5-98.4,98.5h-284.1 c-54.1,0-98.4-44.3-98.4-98.5v-49.6C1900.8,2855.6,1945.1,2811.3,1999.3,2811.3z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st2",
    d: "M2056.4,2950.1h169.8c45.7,0,83.1,37.4,83.1,83.1v31c0,45.7-37.4,83.1-83.1,83.1h-169.8 c-45.7,0-83.1-37.4-83.1-83.1v-31C1973.3,2987.5,2010.7,2950.1,2056.4,2950.1z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    x: 2028.1,
    y: 3038.2,
    className: "st2",
    width: 226.4,
    height: 302.1
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    d: "M1991.4,2875.7h300c14.4,0,26.1,11.7,26.1,26.1v65.5c0,14.4-11.7,26.1-26.1,26.1h-300 c-14.4,0-26.1-11.7-26.1-26.1v-65.5C1965.2,2887.4,1977,2875.7,1991.4,2875.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_57_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3AABFC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_97_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_57_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st8",
    d: "M2215.4,2993.4h76c14.4,0,26.1-11.7,26.1-26.1v-65.5c0-13.9-11-25.3-24.7-26.1l-1.5,0 l-6.2,24.1C2285.2,2899.8,2311.6,2993.4,2215.4,2993.4z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st9",
    d: "M2067.3,2993.4h-76c-14.4,0-26.1-11.7-26.1-26.1v-65.5c0-13.9,11-25.3,24.7-26.1l1.5,0 l6.2,24.1C1997.5,2899.8,1971.1,2993.4,2067.3,2993.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st3",
    d: "M2049.7,3014.5H2233c6.6,0,12,5.4,12,12v44.4c0,6.6-5.4,12-12,12h-183.2c-6.6,0-12-5.4-12-12 v-44.4C2037.7,3020,2043.1,3014.5,2049.7,3014.5z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_54_",
    x: 2092.5,
    y: 3102.6,
    className: "st3",
    width: 97.6,
    height: 173.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st2",
    d: "M1943.6,3299.1h395.5v180.6c0,99.5-81.2,180.6-180.6,180.6h-34.2 c-99.5,0-180.6-81.2-180.6-180.6V3299.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st10",
    d: "M2008,3363.5h266.7v116.2c0,63.9-52.3,116.2-116.2,116.2h-34.2 c-63.9,0-116.2-52.3-116.2-116.2V3363.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st2",
    d: "M1895,3435.7c-0.2-3.6-0.2-7.2-0.2-10.8c0-136.1,110.4-246.5,246.5-246.5 s246.5,110.4,246.5,246.5c0,3.6-0.1,7.2-0.2,10.8l-2.7,61.6h-487.3L1895,3435.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st11",
    d: "M1959.4,3432.9h363.9c0.1-2.7,0.2-5.4,0.2-8.1c0-100.6-81.5-182.1-182.1-182.1 c-100.6,0-182.1,81.5-182.1,182.1C1959.2,3427.6,1959.3,3430.2,1959.4,3432.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st9",
    d: "M1959.4,3432.9h48.6c0,0-11.6-136.8,104.2-187.9c-86.7,13.9-153,89.1-153,179.8 C1959.2,3427.6,1959.3,3430.2,1959.4,3432.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st5",
    d: "M2114.3,3102.6h-21.7v44.8v35.8c7.1-1.4,14.4-2.6,21.7-3.4v-32.4V3102.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st4",
    d: "M2168.4,3102.6h21.7v44.8v35.8c-7.1-1.4-14.4-2.6-21.7-3.4v-32.4V3102.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st5",
    d: "M2049.7,3014.5c-6.6,0-12,5.4-12,12v11.6v19.6v13.1c0,6.6,5.4,12,12,12h13v-25.2v-19.6v-23.7 H2049.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st4",
    d: "M2233,3014.5c6.6,0,12,5.4,12,12v11.6v19.6v13.1c0,6.6-5.4,12-12,12h-13v-25.2v-19.6v-23.7 H2233z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st12",
    d: "M2103.6,3594.1c-36.5-25.8-57.5-70-67.5-96.8h-26.7 C2016.9,3546.2,2055.1,3585.3,2103.6,3594.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st13",
    d: "M2179.1,3594.1c36.5-25.8,57.5-70,67.5-96.8h26.7C2265.8,3546.2,2227.6,3585.3,2179.1,3594.1z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st8",
    d: "M2323.3,3432.9h-48.6c0,0,11.6-136.8-104.2-187.9c86.7,13.9,153,89.1,153,179.8 C2323.5,3427.6,2323.4,3430.2,2323.3,3432.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st2",
    d: "M1752.4,2173.3h777.9c92.7,0,168.6,75.9,168.6,168.6v389.4c0,92.7-75.9,168.6-168.6,168.6 h-777.9c-92.7,0-168.6-75.9-168.6-168.6v-389.4C1583.9,2249.1,1659.7,2173.3,1752.4,2173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st3",
    d: "M1738.8,2237.7h805.1c49.8,0,90.6,40.8,90.6,90.6v416.6c0,49.8-40.8,90.6-90.6,90.6h-805.1 c-49.8,0-90.6-40.8-90.6-90.6v-416.6C1648.3,2278.4,1689,2237.7,1738.8,2237.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_39_",
    className: "st2",
    cx: 1848.6,
    cy: 2394.9,
    r: 140.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_38_",
    x: 2168.3,
    y: 2555.8,
    className: "st2",
    width: 420.7,
    height: 246.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_37_",
    x: 2216.6,
    y: 2604.1,
    className: "st11",
    width: 324.1,
    height: 150
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_36_",
    className: "st2",
    points: "1622.6,2566.4 2063.7,2569.7 2063.7,2454.6 2658.1,2453 2658.1,2518.9 2128.1,2519.3  2127.7,2632.3 1628.7,2629.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st4",
    d: "M2168.3,2754.6h-519.5c4.9,45.3,43.5,80.8,90,80.8H1930h422.8h191.1c46.5,0,85.1-35.5,90-80.8 H2589v47.9h-420.7V2754.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st5",
    d: "M1961.5,2311.8h671.4c-7.8-42-44.9-74.1-89.1-74.1h-805.1c-44.2,0-81.3,32.1-89.1,74.1h85.9 c25.5-34.6,66.6-57.1,112.9-57.1S1936,2277.2,1961.5,2311.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_33_",
    x: 2216.6,
    y: 2715,
    className: "st8",
    width: 324.1,
    height: 39.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_32_",
    x: 2216.6,
    y: 2604.1,
    className: "st9",
    width: 324.1,
    height: 39.2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_31_",
    className: "st4",
    points: "2144.9,2649.7 2145.3,2536.6 2634.4,2536.2 2634.4,2518.9 2128.1,2519.3  2127.7,2632.3 1648.3,2629.9 1648.3,2647.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_30_",
    className: "st5",
    points: "2063.7,2569.7 2063.7,2454.6 2634.4,2453.1 2634.4,2435.8 2046.5,2437.4  2046.5,2552.3 1648.3,2549.3 1648.3,2566.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st11",
    d: "M1848.6,2486.6c50.5,0,91.8-41.2,91.8-91.8c0-50.5-41.2-91.8-91.8-91.8 c-50.5,0-91.8,41.2-91.8,91.8C1756.8,2445.4,1798,2486.6,1848.6,2486.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st8",
    d: "M1849,2466.1c-47.9,0-89.2-34.7-91.4-83.4c-0.5,4-0.8,8.1-0.8,12.2c0,50.7,41.1,91.8,91.8,91.8 c50.7,0,91.8-41.1,91.8-91.8c0-1.4,0-2.8-0.1-4.2C1934.3,2435.5,1896.9,2466.1,1849,2466.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st9",
    d: "M1849.8,2318.1c46.7,0,86.7,30.3,89.4,78.5c0.4-2,0.7-3.9,1-5.9c-2.2-48.7-42.4-87.5-91.7-87.5 c-46.5,0-85,34.7-91,79.6c0,0.4,0,0.7,0.1,1.1C1766.1,2341.8,1803.2,2318.1,1849.8,2318.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st2",
    d: "M1777.6,1974.8h727.6c71.9,0,130.8,58.9,130.8,130.8v0c0,72-58.9,130.8-130.8,130.8h-727.6 c-72,0-130.8-58.9-130.8-130.8v0C1646.8,2033.7,1705.6,1974.8,1777.6,1974.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st11",
    d: "M1777.6,2039.2h727.6c36.5,0,66.4,29.9,66.4,66.4v0c0,36.5-29.9,66.4-66.4,66.4h-727.6 c-36.5,0-66.4-29.9-66.4-66.4v0C1711.2,2069.1,1741,2039.2,1777.6,2039.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st2",
    d: "M1506.6,2028.3c-91.4,0-169.1-62.4-188.7-151.7c-13.2-59.9-19.7-121.1-19.7-182.4 c0-466.8,378.5-845.3,845.3-845.3c466.8,0,845.3,378.5,845.3,845.3c0,61.3-6.6,122.5-19.7,182.4c-19.6,89.3-97.3,151.7-188.7,151.7 H1506.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st3",
    d: "M1506.6,1963.9h1273.7c61.2,0,112.7-41.4,125.8-101.1c11.9-54.3,18.2-110.7,18.2-168.6 c0-431.3-349.6-780.9-780.9-780.9c-431.3,0-780.9,349.6-780.9,780.9c0,57.9,6.3,114.3,18.2,168.6 C1393.9,1922.5,1445.4,1963.9,1506.6,1963.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st2",
    d: "M1613.9,1873.8c-86.7,0-157.9-68.8-160.9-155.5c-0.3-8-0.4-16.1-0.4-24.1 c0-381.6,309.3-690.8,690.8-690.8c381.6,0,690.8,309.3,690.8,690.8c0,8.1-0.1,16.1-0.4,24.1c-3,86.7-74.2,155.5-160.9,155.5H1613.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M1613.9,1809.4h1059c52,0,94.8-41.3,96.5-93.3c0.3-7.3,0.4-14.6,0.4-21.9 c0-346-280.4-626.4-626.4-626.4S1517,1348.2,1517,1694.2c0,7.3,0.1,14.6,0.4,21.9C1519.2,1768.1,1561.9,1809.4,1613.9,1809.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st2",
    d: "M2954.5,1470.8h159c87.6,0,159,71.4,159,159v118.7c0,87.6-71.4,159-159,159h-159V1470.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st11",
    d: "M3018.9,1535.2h94.6c52,0,94.6,42.6,94.6,94.6v118.7c0,52-42.6,94.6-94.6,94.6h-94.6V1535.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st2",
    d: "M1328.2,1471.4h-159c-87.6,0-159,71.4-159,159v118.7c0,87.6,71.4,159,159,159h159V1471.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st11",
    d: "M1263.8,1535.8h-94.6c-52,0-94.6,42.6-94.6,94.6v118.7c0,52,42.6,94.6,94.6,94.6h94.6V1535.8z "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_16_",
    className: "st2",
    points: "2832.9,1456.5 2845.5,1634.2 2786.8,1637.6 2788.5,1682.9 2898.3,1682.9  2884.7,1502.2 2943.4,1497.1 2936.3,1454.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    className: "st2",
    points: "1453.9,1456.5 1441.3,1634.2 1500,1637.6 1498.4,1682.9 1388.5,1682.9 1402.1,1502.2  1343.4,1497.1 1350.6,1454.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    className: "st2",
    points: "1902.7,1008.7 1972.3,1004.1 1975.7,1065.7 2022.2,1061.1 2017.2,952.9 1950.9,957.9  1950.5,913.1 1901.9,914.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_13_",
    className: "st2",
    points: "2384.1,1008.7 2314.5,1004.1 2311.2,1065.7 2264.6,1061.1 2269.7,952.9 2335.9,957.9  2336.3,913.1 2385,914.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M2419.6,1489.7c13.7,0,24.9-11.2,24.9-24.9c0-13.7-11.2-24.9-24.9-24.9 c-13.7,0-24.9,11.2-24.9,24.9C2394.7,1478.6,2405.9,1489.7,2419.6,1489.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M2486.1,1577.2c8,0,14.6-6.6,14.6-14.6c0-8-6.6-14.6-14.6-14.6c-8,0-14.6,6.6-14.6,14.6 C2471.5,1570.7,2478,1577.2,2486.1,1577.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st8",
    d: "M2563.3,2137.7l-845,0c10.3,19.1,32.8,34.4,59.9,34.4l728.6,0 C2533.9,2172,2553,2156.7,2563.3,2137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st9",
    d: "M2560.5,2069.1h-838.4c10.3-17.6,28.3-29.9,55.4-29.9h727.6 C2532.3,2039.2,2550.3,2051.5,2560.5,2069.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st8",
    d: "M1263.8,1795.1c-186.3,10.2-189.2-54.6-189.2-54.6v8.7c0,52,42.6,94.6,94.6,94.6h94.6V1795.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st9",
    d: "M1263.8,1584.5c-186.3-10.2-189.2,54.6-189.2,54.6v-8.7c0-52,42.6-94.6,94.6-94.6h94.6V1584.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st4",
    d: "M2158.2,1916.6c-703.7,34.7-781.8-94.7-790.2-129.3c3,25.6,7.3,50.7,12.8,75.5 c13.1,59.7,64.6,101.1,125.8,101.1h1273.7c61.2,0,112.7-41.4,125.8-101.1c2.1-9.5,4-19.1,5.8-28.8 C2845,1882.3,2661.4,1941.4,2158.2,1916.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st8",
    d: "M3018.9,1794.5c186.3,10.2,189.2-54.6,189.2-54.6v8.7c0,52-42.6,94.6-94.6,94.6h-94.6V1794.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st9",
    d: "M3018.9,1583.9c186.3-10.2,189.2,54.6,189.2,54.6v-8.7c0-52-42.6-94.6-94.6-94.6h-94.6V1583.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st11",
    d: "M2143.4,1003.4c42.1,0,83.3,3.8,123.4,11l2.9-61.4l66.2,5l0.2-20.7 c-61.6-15.6-126.2-24-192.7-24c-66.5,0-131,8.3-192.7,24l0.2,20.7l66.2-5l2.9,61.4C2060.1,1007.1,2101.3,1003.4,2143.4,1003.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M2547.7,1406.7L2547.7,1406.7c12.6,12.1,12.9,32.4,0.8,44.9l-56.5,58.5l56.3,58.7 c12.1,12.6,11.7,32.8-0.9,44.9l0,0c-12.6,12.1-32.8,11.7-44.9-0.9l-54.6-57l-54.8,56.8c-12.1,12.6-32.4,12.9-44.9,0.8l0,0 c-12.6-12.1-12.9-32.4-0.8-44.9l56.5-58.5l-56.3-58.7c-12.1-12.6-11.7-32.8,0.9-44.9l0,0c12.6-12.1,32.8-11.7,44.9,0.9l54.6,57 l54.8-56.8C2514.9,1394.9,2535.1,1394.5,2547.7,1406.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st2",
    d: "M1739.2,1406.7L1739.2,1406.7c-12.6,12.1-12.9,32.4-0.8,44.9l56.5,58.5l-56.3,58.7 c-12.1,12.6-11.7,32.8,0.9,44.9l0,0c12.6,12.1,32.8,11.7,44.9-0.9l54.6-57l54.8,56.8c12.1,12.6,32.4,12.9,44.9,0.8l0,0 c12.6-12.1,12.9-32.4,0.8-44.9l-56.5-58.5l56.3-58.7c12.1-12.6,11.7-32.8-0.9-44.9l0,0c-12.6-12.1-32.8-11.7-44.9,0.9l-54.6,57 l-54.8-56.8C1772,1394.9,1751.8,1394.5,1739.2,1406.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowRobot);
export default __webpack_public_path__ + "static/media/yellow_robot.1a43364088998e7dbc4a9db6681b653b.svg";
export { ForwardRef as ReactComponent };